import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'removeText',
})
export class RemoveTextPipe implements PipeTransform {
  transform(value: string, textToRemove: string): string {
    if (!value) {
      return ''
    }
    return value.replace(textToRemove, '')
  }
}
